import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { GameStateModelBase } from './GameStateModel.base'

/* The TypeScript type of an instance of GameStateModel */
export interface GameStateModelType extends RecursiveRemoveUndefined<Instance<typeof GameStateModel>> {}

/* A graphql query fragment builders for GameStateModel */
export { selectFromGameState, gameStateModelPrimitives, GameStateModelSelector } from './GameStateModel.base'

/**
 * GameStateModel
 */
export const GameStateModel = GameStateModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
